import src from "IMAGE";
export default { src, width: 282, height: 46, blurWidth: 0, blurHeight: 0};
